import React from 'react'
import { Helmet } from 'react-helmet'

const hasDocument = typeof document !== 'undefined'

export default function Head({ children }) {
  const childs = Array.isArray(children) ? children : [children]
  const title = childs.filter((child) => child?.type === 'title')
  const metaDescription = childs.filter((child) => {
    return child?.type === 'meta' && child?.props?.name === 'description'
  })

  // react-helmet won't remove a non-helmet meta tag (like from react-scripts/layout/views/layout.ejs)
  // when one with the same name is passed into helmet so this explicitly checks if meta tag with
  // name of "description" is passed in as a child, and if so, it will remove it from the dom
  if (metaDescription.length) {
    const existingDescription = hasDocument && document.querySelector('meta[name="description"]')

    if (existingDescription) {
      const isReactHelmet = existingDescription?.dataset?.reactHelmet === 'true'
      if (!isReactHelmet) {
        existingDescription.remove()
      }
    }
  }

  if (title.length) {
    throw new Error('<title /> should not be set in <Head />. Please use <Title /> component.')
  }

  return <Helmet>{childs}</Helmet>
}
